import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=ca2e0a88&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=ca2e0a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2e0a88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogShare: require('/opt/build/repo/components/BlogShare.vue').default,BlogFooterCta: require('/opt/build/repo/components/global/BlogFooterCta.vue').default,BlogPostCard: require('/opt/build/repo/components/BlogPostCard.vue').default})
